module.exports = __webpack_public_path__ + "assets/images/emblem-full_plus_2e030b516142e1a13fa680eaacb37581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/new-emblem/emblem-full_plus.png
// module id = 219
// module chunks = 0